module.exports = require("@material/toolbar/dist/mdc.toolbar");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/toolbar/dist/mdc.toolbar","commonjs2":"@material/toolbar/dist/mdc.toolbar","commonjs":"@material/toolbar/dist/mdc.toolbar","amd":"@material/toolbar/dist/mdc.toolbar","umd":"@material/toolbar/dist/mdc.toolbar"}
// module id = 57
// module chunks = 0